import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { trackRetailersPillWithHighlightLowMinClick } from "@faire/web-api--source/events/retailers/click/pillWithHighlightLowMin";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import React from "react";
import styled, { css } from "styled-components";
import { useLoggedOutCategoryPageBannersResponse } from "@faire/retailer/components/Banners/DataFetching/useLoggedOutCategoryPageBannersResponse";
import { LoggedOutCategoryResultsBanner } from "@faire/retailer/components/Banners/LoggedOutCategoryBanners/LoggedOutCategoryResultsBanner";
import { FilterPillTile } from "@faire/retailer/components/FilterPillTile/FilterPillTile";
import { SignUpProductGridBanner } from "@faire/retailer/components/SignUpProductGridBanner/SignUpProductGridBanner";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
export var LoggedOutCategoryBanners = function(param) {
    var banners = param.banners;
    var category = useLoggedOutCategoryPageCurrentCategory();
    var bannersResponse = useLoggedOutCategoryPageBannersResponse().bannersResponse;
    var renderFilterPillTile = function() {
        var _bannersResponse_filter_pill_banner;
        if (!category) {
            return null;
        }
        var _bannersResponse_filter_pill_banner_brand_value_filter_options;
        var brandValueFilterOptions = (_bannersResponse_filter_pill_banner_brand_value_filter_options = bannersResponse === null || bannersResponse === void 0 ? void 0 : (_bannersResponse_filter_pill_banner = bannersResponse.filter_pill_banner) === null || _bannersResponse_filter_pill_banner === void 0 ? void 0 : _bannersResponse_filter_pill_banner.brand_value_filter_options) !== null && _bannersResponse_filter_pill_banner_brand_value_filter_options !== void 0 ? _bannersResponse_filter_pill_banner_brand_value_filter_options : [];
        return /*#__PURE__*/ _jsx(FilterPillTile, {
            currentCategoryModel: category,
            brandValueFilterSection: IFilterSection.build({
                options: brandValueFilterOptions
            }),
            onClick: function(filter) {
                trackRetailersPillWithHighlightLowMinClick(filter, "false");
            }
        });
    };
    var renderBanner = function(banner) {
        switch(banner.type){
            case LoggedOutCategoryResultsBanner.FILTER_PILL_TILE:
                return renderFilterPillTile();
            case LoggedOutCategoryResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER:
                if (bannersResponse === null || bannersResponse === void 0 ? void 0 : bannersResponse.sign_up_product_grid_banner) {
                    return /*#__PURE__*/ _jsx(SignUpProductGridBanner, {
                        info: bannersResponse.sign_up_product_grid_banner
                    });
                } else {
                    return null;
                }
            default:
                return null;
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: banners.map(function(banner, index) {
            var renderedBanner = renderBanner(banner);
            if (!renderedBanner) {
                return null;
            }
            return /*#__PURE__*/ _jsx(BannerTileWrapper, {
                $bannerData: banner,
                children: renderedBanner
            }, "logout-inline-elements-".concat(index));
        })
    });
};
var BannerTileWrapper = styled.div.withConfig({
    componentId: "sc-e1ed7ee8-0"
})([
    "",
    ""
], function(props) {
    return css([
        "grid-column:",
        ";grid-row:",
        " / span 1;"
    ], props.$bannerData.fullRowBanner ? "start/end" : css([
        "",
        " / span ",
        ""
    ], props.$bannerData.column, props.$bannerData.size), props.$bannerData.row);
});
